import { Spinner } from '@vmware-react/clarity';
import React, { Fragment } from 'react';
import { l10n } from '../with-app-root/i18n/i18nUtil';

const defaultSize = 18;

type IconType = 'info' | 'success' | 'warning' | 'danger' | 'loading';

interface Props {
  size?: number;
  type: IconType;
  solid?: boolean;
  className?: string;
}

const GenericIcon: React.SFC<Props> = (props: Props) => {
  let iconClass =
    props.type === 'info'
      ? 'is-info'
      : props.type === 'danger'
      ? 'is-error'
      : props.type === 'warning'
      ? 'is-warning'
      : props.type === 'success'
      ? 'is-success'
      : '';
  iconClass += props.solid ? ' is-solid' : '';

  const iconShape =
    props.type === 'info'
      ? 'info-circle'
      : props.type === 'danger'
      ? 'close-circle'
      : props.type === 'warning'
      ? 'exclamation-circle'
      : props.type === 'success'
      ? 'check-circle'
      : '';
  const title =
    props.type === 'info'
      ? l10n('info')
      : props.type === 'danger'
      ? l10n('error')
      : props.type === 'warning'
      ? l10n('warning')
      : props.type === 'success'
      ? l10n('success')
      : '';

  return (
    <Fragment>
      {props.type === 'loading' ? (
        <Spinner size="sm" />
      ) : (
        <clr-icon
          size={props.size || defaultSize}
          shape={iconShape}
          class={iconClass + ' ' + (props.className || '')}
          title={title}
        />
      )}
    </Fragment>
  );
};

export default GenericIcon;
